import { render, staticRenderFns } from "./ModelType.vue?vue&type=template&id=2275c5e7&scoped=true"
import script from "./ModelType.vue?vue&type=script&lang=js"
export * from "./ModelType.vue?vue&type=script&lang=js"
import style0 from "./ModelType.vue?vue&type=style&index=0&id=2275c5e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2275c5e7",
  null
  
)

export default component.exports